<!--
  - ===========================================================================
  - [StrongGate Limited] [http://www.stronggate.com]
  - Copyright (c) 2023. All rights Reserved.
  - Unauthorized access, use, dissemination, distribution, reproduction of this
  - file, or a portion of, in any form is prohibited and unlawful. If you receive
  - this file, and you are not an authorized company employee, or you believe you
  - have received this file in error, please notify the sender (or originator)
  - and promptly delete this file.
  -
  - Project:
  - File: main.vue
  - Created by: Kevin
  - Create Date: 2023-01-03 13:32
  - Version Number: 1.0
  - Version Description:
  -
  - =============================================================================
  -->

<script>
import {
  layoutComputed
} from "@/state/helpers";
import Vertical from "./vertical.vue";
// import Horizontal from "./horizontal.vue";
import ZtnBacktop from "@/components/input/ztn-backtop.vue";
// import ZtnIdleDialog from "@/components/feedback/ztn-idle-dialog.vue";

export default {
  components: {
    Vertical,
    // Horizontal,
    ZtnBacktop,
    // ZtnIdleDialog,
  },
  data() {
    return {};
  },
  computed: {
    ...layoutComputed,
  },
  methods: {},
  mounted() {
    // document.querySelector("html").setAttribute('dir', 'rtl');
  },
  created() {
  }
};
</script>

<template>
  <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
    <slot/>
  </Vertical>

  <!--    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">-->
  <!--      <slot/>-->
  <!--    </Horizontal>-->

  <ztn-backtop/>
  <!--  <ztn-idle-dialog/>-->
</template>
